module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_37.493341bd.mp3";